module.exports = __webpack_public_path__ + "60e82f2781a162659cb9615c8c5410b0.png";